module.exports = __webpack_public_path__ + "static/img/z9.6be5124.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/z9.png
// module id = WeeB
// module chunks = 0